import Vue from "vue";

if (process.env.VUE_APP_VKTRACKER_ID) {
  Vue.use({
    install: () => {
      const VK_ID = process.env.VUE_APP_VKTRACKER_ID;

      // Start comment
      const commentS = document.createComment("Top.Mail.Ru counter");
      document.body.appendChild(commentS);

      // Script
      const script = document.createElement("script");
      script.text = `var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({id: "${VK_ID}", type: "pageView", start: (new Date()).getTime()});
        (function (d, w, id) {
            if (d.getElementById(id)) return;
            var ts = d.createElement("script"); ts.async = true; ts.id = id;
            ts.src = "https://top-fwz1.mail.ru/js/code.js";
            var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
            if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
        })(document, window, "tmr-code");`;
      document.body.appendChild(script);

      // Noscript
      const noscript = document.createElement("noscript");
      const div = document.createElement("div");
      div.insertAdjacentHTML(
        "beforeend",
        `<img src="https://top-fwz1.mail.ru/counter?id=${VK_ID};js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru">`
      );
      noscript.appendChild(div);
      document.body.appendChild(noscript);

      const commentF = document.createComment("/Top.Mail.Ru counter");
      document.body.appendChild(commentF);
    },
  });
}

export default {};
